export const ictCategories = [
  '01-N001',
  '01-N001-01',
  '01-N001-01-01',
  '01-N001-01-01-01',
  '01-N001-01-01-02',
  '01-N001-01-02',
  '01-N001-01-02-01',
  '01-N001-01-02-02',
  '01-N001-02',
  '01-N001-02-01',
  '01-N001-02-01-01',
  '01-N001-02-01-02',
  '01-N001-02-02',
  '01-N001-02-02-01',
  '01-N001-02-02-02',
  '01-N001-03',
  '01-N001-03-01',
  '01-N001-03-01-01',
  '01-N001-03-01-02',
  '01-N001-03-02',
  '01-N001-03-02-01',
  '01-N001-03-02-02',
  '01-N001-04',
  '01-N001-04-01',
  '01-N001-04-01-01',
  '01-N001-04-01-02',
  '01-N001-04-02',
  '01-N001-04-02-01',
  '01-N001-04-02-02',
  '01-N001-05',
  '01-N001-05-01',
  '01-N001-05-01-01',
  '01-N001-05-01-02',
  '01-N001-05-02',
  '01-N001-05-02-01',
  '01-N001-05-02-02',
  '01-N001-06',
  '01-N001-06-01',
  '01-N001-06-01-01',
  '01-N001-06-01-02',
  '01-N001-06-02',
  '01-N001-06-02-01',
  '01-N001-06-02-02',
  '01-N001-07',
  '01-N001-07-01',
  '01-N001-07-02',
  '01-N001-08',
  '01-N001-08-01',
  '01-N001-08-01-01',
  '01-N001-08-02',
  '01-N001-08-02-01',
  '01-N001-09',
  '01-N001-09-01',
  '01-N001-09-01-01',
  '01-N001-09-01-02',
  '01-N001-09-02',
  '01-N001-09-02-01',
  '01-N001-09-02-02',
  '01-N001-10',
  '01-N001-10-01',
  '01-N001-10-01-01',
  '01-N001-10-01-02',
  '01-N001-10-02',
  '01-N001-10-02-01',
  '01-N001-10-02-02',
  '01-N001-11',
  '01-N001-11-01',
  '01-N001-11-01-01',
  '01-N001-11-01-02',
  '01-N001-11-02',
  '01-N001-11-02-01',
  '01-N001-11-02-02',
  '01-N001-12',
  '01-N001-12-01',
  '01-N001-12-01-01',
  '01-N001-12-01-02',
  '01-N001-12-02',
  '01-N001-12-02-01',
  '01-N001-12-02-02',
  '01-N001-99',
  '01-N001-99-01',
  '01-N001-99-02',
  '01-N002',
  '01-N002-01',
  '01-N002-01-01',
  '01-N002-01-02',
  '01-N002-01-03',
  '01-N002-01-04',
  '01-N002-01-05',
  '01-N002-01-99',
  '01-N002-02',
  '01-N002-03',
  '01-N002-04',
  '01-N002-04-01',
  '01-N002-04-02',
  '01-N002-05',
  '01-N002-05-01',
  '01-N002-05-02',
  '01-N002-05-99',
  '01-N002-06',
  '01-N002-07',
  '01-N002-08',
  '01-N002-08-01',
  '01-N002-08-01-01',
  '01-N002-08-01-02',
  '01-N002-08-01-03',
  '01-N002-08-01-04',
  '01-N002-08-01-05',
  '01-N002-08-01-06',
  '01-N002-08-01-99',
  '01-N002-08-02',
  '01-N002-08-03',
  '01-N002-08-04',
  '01-N002-08-05',
  '01-N002-08-06',
  '01-N002-08-07',
  '01-N002-08-08',
  '01-N002-08-09',
  '01-N002-08-99',
  '01-N003',
  '01-N003-01',
  '01-N003-01-01',
  '01-N003-01-02',
  '01-N003-01-99',
  '01-N003-02',
  '01-N003-02-01',
  '01-N003-02-02',
  '01-N003-02-03',
  '01-N003-02-04',
  '01-N003-02-05',
  '01-N003-02-06',
  '01-N003-02-07',
  '01-N003-02-08',
  '01-N003-02-09',
  '01-N003-02-10',
  '01-N003-02-11',
  '01-N003-02-12',
  '01-N003-02-13',
  '01-N003-02-14',
  '01-N003-02-15',
  '01-N003-02-99',
  '01-N003-03',
  '01-N003-04',
  '01-N003-04-01',
  '01-N003-04-02',
  '01-N004',
  '01-N004-01',
  '01-N004-02',
  '01-N004-03',
  '01-N004-04',
  '01-N004-05',
  '01-N005',
  '02-N001',
  '02-N001-01',
  '02-N001-01-01',
  '02-N001-01-02',
  '02-N001-01-02-01',
  '02-N001-01-02-02',
  '02-N001-01-02-03',
  '02-N001-01-03',
  '02-N001-01-04',
  '02-N001-02',
  '02-N001-02-01',
  '02-N001-02-02',
  '02-N001-02-03',
  '02-N001-02-04',
  '02-N001-02-05',
  '02-N001-03',
  '02-N001-03-01',
  '02-N001-03-02',
  '02-N001-04',
  '02-N001-04-01',
  '02-N001-04-02',
  '02-N001-05',
  '02-N001-05-01',
  '02-N001-05-02',
  '02-N001-06',
  '02-N001-06-01',
  '02-N001-06-02',
  '02-N001-07',
  '02-N001-08',
  '02-N001-09',
  '02-N001-10',
  '02-N001-11',
  '02-N001-11-01',
  '02-N001-11-02',
  '02-N001-12',
  '02-N001-13',
  '02-N001-99',
  '02-N001-99-01',
  '02-N001-99-02',
  '02-N002',
  '02-N002-01',
  '02-N002-01-01',
  '02-N002-01-02',
  '02-N002-01-03',
  '02-N002-01-04',
  '02-N002-01-99',
  '02-N002-02',
  '02-N002-03',
  '02-N002-04',
  '02-N002-05',
  '02-N003',
  '02-N003-01',
  '02-N003-01-01',
  '02-N003-01-02',
  '02-N003-01-03',
  '02-N003-02',
  '02-N003-02-01',
  '02-N003-02-02',
  '02-N003-02-03',
  '02-N003-02-04',
  '02-N003-02-05',
  '02-N003-02-06',
  '02-N003-02-07',
  '02-N003-02-08',
  '02-N003-02-09',
  '02-N004',
  '02-N004-01',
  '02-N004-02',
  '02-N004-03',
  '02-N004-04',
  '02-N004-05',
  '02-N004-06',
  '02-N004-07',
  '02-N004-08',
  '02-N004-09',
  '02-N004-10',
  '02-N004-11',
  '02-N004-12',
  '02-N004-99',
  '02-N005',
  '02-N005-01',
  '02-N005-01-01',
  '02-N005-01-02',
  '02-N005-01-03',
  '02-N005-01-04',
  '02-N005-01-05',
  '02-N005-01-06',
  '02-N005-01-07',
  '02-N005-01-08',
  '02-N005-01-09',
  '02-N005-01-10',
  '02-N005-01-11',
  '02-N005-01-12',
  '02-N005-01-13',
  '02-N005-01-14',
  '02-N005-01-15',
  '02-N005-01-99',
  '02-N005-02',
  '02-N005-02-01',
  '02-N005-02-02',
  '02-N005-02-03',
  '02-N005-02-99',
  '02-N006',
  '02-N006-01',
  '02-N006-02',
  '02-N006-03',
  '02-N006-04',
  '02-N006-05',
  '02-N006-06',
  '02-N006-07',
  '02-N006-08',
  '02-N006-09',
  '02-N006-10',
  '02-N006-11',
  '02-N006-12',
  '02-N006-13',
  '02-N006-99',
  '02-N007',
  '02-N007-01',
  '02-N007-02',
  '02-N007-03',
  '02-N008',
  '02-N008-01',
  '02-N008-02',
  '02-N008-03',
  '02-N008-04',
  '02-N008-05',
  '02-N008-06',
  '02-N008-07',
  '02-N008-08',
  '02-N008-09',
  '02-N008-10',
  '02-N008-11',
  '02-N008-99',
  '02-N009',
  '02-N009-01',
  '02-N009-02',
  '02-N009-03',
  '02-N009-04',
  '02-N009-05',
  '02-N009-06',
  '02-N009-07',
  '02-N009-08',
  '02-N009-09',
  '02-N009-10',
  '02-N009-11',
  '02-N009-12',
  '02-N009-13',
  '02-N009-14',
  '02-N009-15',
  '02-N009-16',
  '02-N009-17',
  '02-N009-18',
  '02-N009-19',
  '02-N009-99',
  '02-N010',
  '02-N010-01',
  '02-N010-02',
  '02-N010-03',
  '02-N010-04',
  '02-N010-05',
  '02-N010-06',
  '02-N010-07',
  '02-N010-08',
  '02-N010-09',
  '02-N010-10',
  '02-N010-11',
  '02-N010-12',
  '02-N010-13',
  '02-N010-14',
  '02-N010-15',
  '02-N010-99',
  '02-N011',
  '02-N011-01',
  '02-N011-02',
  '02-N012',
  '02-N012-01',
  '02-N012-02',
  '02-N012-03',
  '03-N001',
  '03-N001-01',
  '03-N001-02',
  '03-N001-03',
  '03-N001-04',
  '03-N001-05',
  '03-N001-06',
  '03-N001-07',
  '03-N001-08',
  '03-N001-09',
  '03-N001-10',
  '03-N001-11',
  '03-N001-12',
  '03-N001-99',
  '03-N002',
  '03-N002-01',
  '03-N002-02',
  '03-N002-03',
  '03-N002-04',
  '03-N002-05',
  '03-N002-06',
  '03-N002-07',
  '03-N002-08',
  '03-N002-09',
  '03-N002-10',
  '03-N002-11',
  '03-N002-12',
  '03-N002-13',
  '03-N002-14',
  '03-N002-15',
  '03-N002-16',
  '03-N002-17',
  '03-N002-18',
  '03-N002-19',
  '03-N002-20',
  '03-N002-21',
  '03-N002-22',
  '03-N002-23',
  '03-N002-99',
  '03-N003',
  '03-N003-01',
  '03-N003-02',
  '03-N003-03',
  '03-N003-04',
  '03-N003-05',
  '03-N003-99',
  '03-N004',
  '03-N004-01',
  '03-N004-02',
  '03-N004-03',
  '03-N004-04',
  '03-N004-05',
  '03-N004-06',
  '03-N004-07',
  '03-N004-08',
  '03-N004-09',
  '03-N004-10',
  '03-N004-11',
  '03-N004-12',
  '03-N004-13',
  '03-N004-14',
  '03-N004-15',
  '03-N004-16',
  '03-N004-17',
  '03-N004-18',
  '03-N004-19',
  '03-N004-20',
  '03-N004-21',
  '03-N004-22',
  '03-N004-23',
  '03-N004-24',
  '03-N004-25',
  '03-N004-26',
  '03-N004-27',
  '03-N004-28',
  '03-N004-29',
  '03-N004-30',
  '03-N004-31',
  '03-N004-99',
  '03-N005',
  '03-N005-01',
  '03-N005-02',
  '03-N005-03',
  '03-N005-04',
  '03-N005-05',
  '03-N005-06',
  '03-N005-07',
  '03-N005-08',
  '03-N005-09',
  '03-N005-10',
  '03-N005-11',
  '03-N005-12',
  '03-N005-13',
  '03-N005-14',
  '03-N005-15',
  '03-N005-16',
  '03-N005-17',
  '03-N005-18',
  '03-N005-19',
  '03-N005-20',
  '03-N005-21',
  '03-N005-22',
  '03-N005-23',
  '03-N005-24',
  '03-N005-25',
  '03-N005-26',
  '03-N005-27',
  '03-N005-28',
  '03-N005-29',
  '03-N005-30',
  '03-N005-31',
  '03-N005-32',
  '03-N005-33',
  '03-N005-34',
  '03-N005-35',
  '03-N005-36',
  '03-N005-37',
  '03-N005-38',
  '03-N005-99',
  '03-N006',
  '03-N006-01',
  '03-N006-01-01',
  '03-N006-01-02',
  '03-N006-02',
  '03-N006-02-01',
  '03-N006-02-02',
  '03-N006-02-03',
  '03-N006-02-04',
  '03-N006-02-05',
  '03-N006-02-06',
  '03-N006-02-07',
  '03-N006-02-08',
  '03-N006-02-99',
  '03-N006-03',
  '03-N006-03-01',
  '03-N006-03-02',
  '03-N006-03-03',
  '03-N006-03-04',
  '03-N006-03-99',
  '03-N006-04',
  '03-N006-04-01',
  '03-N006-04-02',
  '03-N006-04-03',
  '03-N006-04-04',
  '03-N006-04-05',
  '03-N006-04-06',
  '03-N006-04-07',
  '03-N006-04-08',
  '03-N006-04-99',
  '03-N006-05',
  '03-N006-05-01',
  '03-N006-05-02',
  '03-N006-05-03',
  '03-N007',
  '03-N007-01',
  '03-N007-02',
  '03-N099',
  '03-N099-01',
  '03-N099-04',
  '03-N099-05',
  '04-N001',
  '04-N001-01',
  '04-N001-01-01',
  '04-N001-01-01-01',
  '04-N001-01-01-01-01',
  '04-N001-01-01-01-02',
  '04-N001-01-01-01-03',
  '04-N001-01-01-02',
  '04-N001-01-01-02-01',
  '04-N001-01-01-02-02',
  '04-N001-01-01-02-03',
  '04-N001-01-01-02-04',
  '04-N001-01-02',
  '04-N001-01-02-01',
  '04-N001-01-02-02',
  '04-N001-02',
  '04-N001-03',
  '04-N001-03-01',
  '04-N001-03-02',
  '04-N001-04',
  '04-N001-98',
  '04-N001-98-01',
  '04-N001-98-02',
  '04-N001-98-03',
  '04-N001-99',
  '04-N002',
  '04-N002-01',
  '04-N002-02',
  '04-N002-03',
  '04-N002-04',
  '04-N002-05',
  '04-N003',
  '04-N003-01',
  '04-N003-02',
  '04-N003-03',
  '04-N003-04',
  '04-N003-05',
  '04-N004',
  '04-N004-01',
  '04-N004-02',
  '04-N004-03',
  '04-N004-04',
  '04-N004-05',
  '04-N004-06',
  '04-N004-07',
  '04-N004-99',
  '04-N005',
  '04-N005-01',
  '04-N005-01-01',
  '04-N005-01-02',
  '04-N005-01-03',
  '04-N005-01-04',
  '04-N005-01-05',
  '04-N005-01-06',
  '04-N005-01-99',
  '04-N005-02',
  '04-N005-02-01',
  '04-N005-02-02',
  '04-N005-02-03',
  '04-N006',
  '04-N007',
  '04-N007-01',
  '04-N007-01-01',
  '04-N007-01-01-01',
  '04-N007-01-01-02',
  '04-N007-01-02',
  '04-N007-01-02-01',
  '04-N007-01-02-02',
  '04-N007-01-03',
  '04-N007-01-03-01',
  '04-N007-01-03-02',
  '04-N007-01-04',
  '04-N007-01-04-01',
  '04-N007-01-04-02',
  '04-N007-01-05',
  '04-N007-01-05-01',
  '04-N007-01-05-02',
  '04-N007-01-06',
  '04-N007-01-06-01',
  '04-N007-01-06-02',
  '04-N007-01-07',
  '04-N007-01-07-01',
  '04-N007-01-07-02',
  '04-N007-01-08',
  '04-N007-01-08-01',
  '04-N007-01-08-02',
  '04-N007-01-99',
  '04-N007-01-99-01',
  '04-N007-01-99-02',
  '04-N007-02',
  '04-N007-02-01',
  '04-N007-02-99',
  '04-N007-03',
  '04-N007-04',
  '04-N008',
  '04-N008-01',
  '04-N008-02',
  '04-N008-03',
  '04-N008-04',
  '04-N008-05',
  '04-N008-99',
  '04-N009',
  '04-N009-01',
  '04-N009-02',
  '04-N009-03',
  '04-N010',
  '04-N010-01',
  '04-N010-01-01',
  '04-N010-01-02',
  '04-N010-01-03',
  '04-N010-01-04',
  '04-N010-01-05',
  '04-N010-01-06',
  '04-N010-01-99',
  '04-N010-02',
  '04-N010-02-01',
  '04-N010-02-02',
  '04-N010-02-03',
  '04-N010-02-04',
  '04-N010-02-99',
  '04-N010-03',
  '04-N010-04',
  '04-N011',
  '04-N011-01',
  '04-N011-02',
  '04-N012',
  '04-N012-01',
  '04-N012-02',
  '04-N012-03',
  '04-N013',
  '04-N013-01',
  '04-N013-02',
  '04-N013-03',
  '04-N013-04',
  '04-N013-05',
  '04-N013-06',
  '04-N013-07',
  '04-N013-08',
  '04-N013-99',
  '04-N014',
  '04-N014-01',
  '04-N014-02',
  '04-N015',
  '04-N015-01',
  '04-N015-02',
  '04-N016',
  '04-N016-01',
  '04-N016-02',
  '04-N017',
  '04-N017-01',
  '04-N017-02',
  '04-N017-03',
  '04-N017-99',
  '04-N018',
  '04-N018-01',
  '04-N018-99',
  '04-N019',
  '04-N019-01',
  '04-N019-02',
  '04-N019-99',
  '04-N020',
  '04-N020-01',
  '04-N020-98',
  '04-N021',
  '04-N021-01',
  '04-N021-02',
  '04-N021-03',
  '04-N022',
  '04-N023',
  '04-N024',
  '04-N024-01',
  '04-N024-02',
  '04-N024-03',
  '04-N024-04',
  '04-N024-05',
  '04-N024-99',
  '04-N025',
  '04-N025-01',
  '04-N025-99',
  '04-N026',
  '04-N026-01',
  '04-N026-02',
  '04-N026-03',
  '04-N026-04',
  '04-N026-05',
  '04-N026-99',
  '04-N026-99-01',
  '04-N027',
  '04-N027-01',
  '04-N027-01-01',
  '04-N027-01-01-01',
  '04-N027-01-01-02',
  '04-N027-01-01-03',
  '04-N027-01-02',
  '04-N027-01-02-01',
  '04-N027-01-02-02',
  '04-N027-01-02-03',
  '04-N027-01-03',
  '04-N027-01-03-01',
  '04-N027-01-03-02',
  '04-N027-01-04',
  '04-N027-01-04-01',
  '04-N027-01-04-02',
  '04-N027-01-05',
  '04-N027-01-05-01',
  '04-N027-01-05-02',
  '04-N027-01-07',
  '04-N027-01-07-01',
  '04-N027-01-07-02',
  '04-N027-01-08',
  '04-N027-01-08-01',
  '04-N027-01-08-02',
  '04-N027-01-08-03',
  '04-N027-01-09',
  '04-N027-01-09-01',
  '04-N027-01-09-02',
  '04-N027-01-10',
  '04-N027-01-10-01',
  '04-N027-01-10-02',
  '04-N027-01-99',
  '04-N027-02',
  '04-N027-02-01',
  '04-N027-02-02',
  '04-N027-02-03',
  '04-N027-02-04',
  '04-N027-02-05',
  '04-N027-02-06',
  '04-N027-02-07',
  '04-N027-02-99',
  '04-N027-03',
  '04-N027-04',
  '04-N027-04-01',
  '04-N027-04-02',
  '04-N027-05',
  '04-N028',
  '04-N028-01',
  '04-N028-99',
  '05-N001',
  '05-N001-01',
  '05-N001-02',
  '05-N001-03',
  '05-N001-04',
  '05-N001-05',
  '05-N001-06',
  '05-N001-07',
  '05-N001-08',
  '05-N001-09',
  '05-N001-10',
  '05-N001-11',
  '05-N001-12',
  '05-N001-13',
  '05-N001-14',
  '05-N001-15',
  '05-N001-16',
  '05-N001-17',
  '05-N001-18',
  '05-N001-19',
  '05-N001-20',
  '05-N001-99',
  '05-N002',
  '05-N002-01',
  '05-N002-02',
  '05-N002-03',
  '05-N002-04',
  '05-N002-05',
  '05-N002-06',
  '05-N002-07',
  '05-N002-08',
  '05-N002-09',
  '05-N002-99',
  '05-N003',
  '05-N003-01',
  '05-N003-01-01',
  '05-N003-01-02',
  '05-N003-01-03',
  '05-N003-01-04',
  '05-N003-01-05',
  '05-N003-01-06',
  '05-N003-01-07',
  '05-N003-01-08',
  '05-N003-01-09',
  '05-N003-01-10',
  '05-N003-01-11',
  '05-N003-01-12',
  '05-N003-01-13',
  '05-N003-01-14',
  '05-N003-01-99',
  '05-N003-02',
  '05-N003-02-01',
  '05-N003-02-02',
  '05-N003-02-03',
  '05-N003-02-04',
  '05-N003-02-05',
  '05-N003-02-06',
  '05-N003-02-07',
  '05-N003-02-08',
  '05-N003-02-09',
  '05-N003-02-10',
  '05-N003-02-11',
  '05-N003-02-12',
  '05-N003-02-13',
  '05-N003-02-14',
  '05-N003-02-15',
  '05-N003-02-99',
  '05-N003-03',
  '05-N003-03-01',
  '05-N003-03-02',
  '05-N003-03-03',
  '05-N003-03-04',
  '05-N003-03-05',
  '05-N003-03-06',
  '05-N003-03-07',
  '05-N003-03-08',
  '05-N003-03-09',
  '05-N003-03-99',
  '05-N003-04',
  '05-N003-04-01',
  '05-N003-04-02',
  '05-N003-04-03',
  '05-N003-04-04',
  '05-N003-04-05',
  '05-N003-04-06',
  '05-N003-04-07',
  '05-N003-04-08',
  '05-N003-04-09',
  '05-N003-04-99',
  '05-N003-05',
  '05-N003-05-01',
  '05-N003-05-01-01',
  '05-N003-05-01-02',
  '05-N003-05-01-03',
  '05-N003-05-01-04',
  '05-N003-05-01-99',
  '05-N003-05-02',
  '05-N003-05-02-01',
  '05-N003-05-02-02',
  '05-N003-05-02-03',
  '05-N003-05-02-04',
  '05-N003-05-02-99',
  '05-N003-05-03',
  '05-N003-06',
  '05-N003-07',
  '05-N003-08',
  '05-N003-09',
  '05-N003-09-01',
  '05-N003-09-99',
  '05-N003-10',
  '05-N003-11',
  '05-N003-12',
  '05-N003-12-01',
  '05-N003-12-02',
  '05-N003-13',
  '05-N004',
  '05-N004-01',
  '05-N004-01-01',
  '05-N004-01-02',
  '05-N004-01-03',
  '05-N004-01-99',
  '05-N004-02',
  '05-N004-03',
  '05-N004-03-01',
  '05-N004-03-01-01',
  '05-N004-03-01-02',
  '05-N004-03-01-03',
  '05-N004-03-02',
  '05-N004-03-03',
  '05-N004-03-04',
  '05-N005',
  '05-N005-01',
  '05-N005-02',
  '05-N005-03',
  '05-N006',
  '05-N006-01',
  '05-N006-02',
  '05-N006-03',
  '05-N006-04',
  '05-N007',
  '05-N007-01',
  '05-N008',
  '05-N008-01',
  '05-N008-02',
  '05-N008-03',
  '05-N008-04',
  '05-N008-05',
  '05-N008-99',
  '06-N001',
  '06-N001-01',
  '06-N001-02',
  '06-N001-02-01',
  '06-N001-02-02',
  '06-N001-02-03',
  '06-N001-02-04',
  '06-N001-02-05',
  '06-N001-02-06',
  '06-N001-02-07',
  '06-N001-02-08',
  '06-N001-02-09',
  '06-N001-02-10',
  '06-N001-02-11',
  '06-N001-02-12',
  '06-N001-02-13',
  '06-N001-02-14',
  '06-N001-02-15',
  '06-N001-02-16',
  '06-N001-02-17',
  '06-N001-02-18',
  '06-N001-02-19',
  '06-N001-02-99',
  '06-N001-03',
  '06-N001-04',
  '06-N001-05',
  '06-N001-06',
  '06-N001-07',
  '06-N001-07-01',
  '06-N001-07-02',
  '06-N001-08',
  '06-N001-09',
  '06-N001-10',
  '06-N001-11',
  '06-N001-12',
  '06-N001-13',
  '06-N001-14',
  '06-N001-15',
  '06-N001-99',
  '06-N002',
  '06-N002-01',
  '06-N002-02',
  '06-N002-03',
  '06-N002-04',
  '06-N002-05',
  '06-N002-06',
  '06-N002-07',
  '06-N002-08',
  '06-N002-09',
  '06-N002-10',
  '06-N002-11',
  '06-N002-99',
  '06-N003',
  '06-N003-01',
  '06-N003-02',
  '06-N003-03',
  '06-N003-04',
  '06-N003-05',
  '06-N003-06',
  '06-N003-07',
  '06-N003-08',
  '06-N003-09',
  '06-N003-99',
  '06-N004',
  '06-N004-01',
  '06-N004-02',
  '06-N004-02-01',
  '06-N004-02-99',
  '06-N004-03',
  '06-N005',
  '06-N005-01',
  '06-N005-02',
  '06-N005-03',
  '06-N005-04',
  '06-N005-05',
  '06-N006',
  '06-N007',
  '06-N008',
  '06-N008-01',
  '06-N008-02',
  '06-N008-03',
  '06-N008-04',
  '06-N008-05',
  '06-N008-06',
  '06-N008-99',
  '06-N009',
  '06-N010',
  '06-N010-01',
  '06-N010-02',
  '06-N010-03',
  '06-N010-04',
  '06-N010-99',
  '06-N011',
  '06-N011-01',
  '06-N011-02',
  '06-N011-03',
  '06-N011-04',
  '06-N011-05',
  '06-N011-06',
  '06-N011-07',
  '06-N011-08',
  '06-N011-09',
  '06-N011-10',
  '06-N011-11',
  '06-N011-12',
  '06-N011-13',
  '06-N011-14',
  '06-N011-99',
  '06-N012',
  '06-N012-01',
  '06-N013',
  '06-N013-01',
  '06-N013-02',
  '06-N013-03',
  '06-N013-04',
  '06-N013-05',
  '06-N013-06',
  '06-N013-07',
  '06-N013-08',
  '06-N013-09',
  '06-N013-10',
  '06-N013-11',
  '06-N013-12',
  '06-N013-99',
  '06-N014',
  '06-N014-01',
  '06-N014-02',
  '06-N014-99',
  '06-N015',
  '06-N015-01',
  '06-N015-02',
  '06-N015-03',
  '06-N015-04',
  '06-N015-05',
  '06-N015-06',
  '06-N015-07',
  '06-N015-08',
  '06-N015-99',
  '06-N016',
  '06-N016-01',
  '06-N016-99',
  '06-N017',
  '06-N017-01',
  '06-N017-02',
  '06-N018',
  '06-N018-01',
  '06-N019',
  '06-N019-01',
  '06-N019-02',
  '06-N020',
  '06-N020-01',
  '06-N020-01-01',
  '06-N020-01-02',
  '06-N020-02',
  '06-N020-02-01',
  '06-N020-02-02',
  '06-N020-03',
  '06-N020-03-01',
  '06-N020-03-02',
  '06-N020-03-03',
  '06-N020-03-04',
  '06-N020-03-05',
  '06-N020-04',
  '06-N020-04-01',
  '06-N020-04-02',
  '06-N099',
  '06-N099-01',
  '06-N099-02',
  '06-N099-03',
  '06-N099-04',
  '06-N099-05',
  '06-N099-06',
  '06-N099-07',
  '06-N099-08',
  '06-N099-09',
  '06-N099-99',
  '07-N001',
  '07-N001-01',
  '07-N001-01-01',
  '07-N001-01-02',
  '07-N001-01-99',
  '07-N001-02',
  '07-N001-03',
  '07-N001-04',
  '07-N002',
  '07-N002-01',
  '07-N002-02',
  '07-N003',
  '07-N004',
  '07-N004-01',
  '07-N005',
  '07-N006',
  '07-N006-01',
  '07-N006-02',
  '07-N006-03',
  '07-N006-04',
  '07-N006-05',
  '07-N006-06',
  '07-N006-07',
  '09-N001',
  '09-N002',
  '09-N003',
  '09-N004',
  '10-N001',
  '10-N001-01',
  '10-N001-02',
  '10-N001-03',
  '10-N001-04',
  '10-N001-05',
  '10-N001-06',
  '10-N001-07',
  '10-N001-08',
  '10-N002',
  '10-N002-01',
  '10-N002-02',
  '10-N002-03',
  '10-N002-04',
  '10-N002-05',
  '10-N002-06',
  '10-N002-07',
  '10-N003',
  '10-N003-01',
  '10-N003-02',
  '10-N003-03',
  '10-N003-04',
  '10-N003-05',
  '10-N003-06',
  '10-N003-07',
  '10-N004',
  '10-N004-01',
  '10-N004-02',
  '10-N004-03',
  '10-N004-04',
  '10-N004-05',
  '10-N004-06',
  '10-N004-07',
  '10-N004-08',
  '10-N004-09',
  '10-N004-10',
  '10-N004-11',
  '10-N005',
  '10-N005-01',
  '10-N005-02',
  '10-N005-03',
  '10-N005-04',
  '10-N005-05',
  '10-N005-06',
  '98-N001',
  '98-N002',
  '98-N003',
  '99-N001',
  '99-N002',
  '99-N003',
  '99-N003-01',
  '99-N003-02',
  '99-N003-03',
  '99-N003-04',
  '99-N003-05',
  '99-N003-06',
  '99-N003-07',
  '99-N003-08',
  '99-N003-09',
  '99-N003-10',
  '99-N003-11',
  '99-N003-12',
  '99-N003-13',
  '99-N003-14',
  '99-N003-15',
  '99-N003-16',
  '99-N003-17',
  '99-N003-18',
  '99-N003-99',
];
export const alcoholicCatCodes: string[] = [
  '009-003-001-001',
  '009-003-001-003',
];
export const ippAlcoholicCatCodes: string[] = ['ruou-manh', 'ruou-vang', 'bia'];
